// extracted by mini-css-extract-plugin
module.exports = {"root":"IsoImage-module--root--35JXS","screen":"IsoImage-module--screen--30jtX"};